export const LAPTOP_WIDTH = 1024;
export const MOBILE_WIDTH = 790;
export const SMALL_MOBILE_WIDTH = 425;

export const SERVER = {
	DEFAULT_IP: "localhost",
	DEFAULT_PORT: "9000",
	DEFAULT_AUTO_PRINT: "true",
	DEFAULT_PURCHASE: "true"
}